import React, { FC } from 'react'

import type { ButtonProps } from '../../Button'
import { Button } from '../../Button'
import { SetStepCursor, StepCursor } from '../../FullScreenStepper/FullScreenStepperProps'
import { augmentButtonProps } from './augmentButtonProps'

export const StepperActionsPreviousButton: FC<{
  previousButtonText?: string
  stepCursor: StepCursor
  handlePreviousClick: () => Promise<void>
  previousButtonProps?: ButtonProps
  setStepCursor: SetStepCursor
  displayPreviousButton: boolean
}> = (props) => {
  const {
    previousButtonText,
    stepCursor,
    handlePreviousClick,
    previousButtonProps,
    setStepCursor,
    displayPreviousButton,
  } = props

  const augmentedPreviousButtonProps = augmentButtonProps(
    { onClick: handlePreviousClick },
    previousButtonProps,
    setStepCursor,
    stepCursor,
    -1,
  )

  return displayPreviousButton ? (
    <Button variant="tertiary" disabled={stepCursor === 1} {...augmentedPreviousButtonProps}>
      {previousButtonText || 'previous'}
    </Button>
  ) : null
}
